<template>
    <ContainerLayout page="0">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link to="/profile" class="nav-link">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
                <!-- <div class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link to="/register" class="nav-link">
                            <font-awesome-icon icon="pencil" class="text-secondary" />
                        </router-link>
                    </li>
                </div> -->
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div class="content">
            <div class="d-flex flex-column">
                <div class="mb-5">
                    <div class="mb-3">
                        <div class="d-flex justify-content-center align-items-center">
                            <img id="profile-img" class="profile-img" src="//ssl.gstatic.com/accounts/ui/avatar_2x.png" />
                        </div>
                    </div>
                    <div class="mb-1">
                        <div class="d-flex justify-content-center align-items-center">
                            <h5 class="font-weight-bold mb-0">{{ currentUser ? currentUser.name : '' }}</h5>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex justify-content-center align-items-center">
                            <span>{{ currentUser ? currentUser.email : '' }}</span>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex justify-content-center align-items-center">
                            <span>{{ currentUser ? currentUser.phone : '' }}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="mb-3">
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-row align-items-center">
                            <span class="font-weight-bold">Alamat</span>
                        </div>
                        <div class="d-flex flex-row align-items-center">
                            <span>Alamat</span>
                        </div>
                    </div>
                    <hr>
                </div> -->
            </div>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";

export default {
    name: "ProfileDetail",
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
    },
    data() {
        return {
            //
        };
    },
    components: {
        ContainerLayout
    },
    methods: {
        //
    }
};
</script>
  